/**
 * Accent-folded search for the song library ("olafur" finds "Ólafur", "thorsteinn" finds "Þorsteinn").
 * Kept local to the library screens on purpose (a shared lib/search.ts is written in parallel).
 */
export function fold(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/þ/g, 'th')
    .replace(/æ/g, 'ae')
    .replace(/ð/g, 'd')
    .replace(/ø/g, 'o')
    .replace(/œ/g, 'oe')
    .replace(/ß/g, 'ss');
}

/** Query → folded tokens (all must match). */
export function queryTokens(q: string): string[] {
  return fold(q)
    .split(/[\s,.;:!?"'„“”()\-–—/]+/)
    .filter(Boolean);
}

export function matchesTokens(haystackFolded: string, tokens: readonly string[]): boolean {
  for (const t of tokens) if (!haystackFolded.includes(t)) return false;
  return true;
}

/** Build a folded haystack from the given fields (nulls ignored). */
export function haystack(...fields: (string | null | undefined)[]): string {
  return fold(fields.filter(Boolean).join(' '));
}
